<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <v-footer v-if="windowWidth > 820" />
    <v-footermo v-else />
    <v-showwhatsapp></v-showwhatsapp>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      windowWidth: document.documentElement.clientWidth,
    };
  },
  mounted() {
    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = document.documentElement.clientWidth;
        this.swiperLoad();
      },
      false
    );
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 页面加载后获取窗口大小
    swiperLoad() {
      this.$nextTick(() => {
        this.windowWidth = document.documentElement.clientWidth;
      });
    },
  },
  components: {
    "v-showwhatsapp": () => import("../src/components/showwhatsapp"),
    "v-footer": () => import("../src/components/footer.vue"),
    "v-footermo": () => import("../src/components/footerMo.vue"),
  },
};
</script>

<style>
@import "./components/common/font/font.css";
#app {
  margin: 0px;
  padding: 0px;
  background-size: 100% 100%;
  font-family: sans-serif;
}
li {
  /* display: inline-block; */
  list-style: none;
}
</style>
